export const GPX_EVENT_TYPES = {
  CLICK: 'click',
  API_RESPONSE: 'api_response',
  API_REQUEST: 'api_request',
  API_PUSH: 'api_push',
  INFO: 'info',
} as const;

export const GPX_CAPABILITIES = {
  VIDEO_STREAMING: 'video_streaming',
  MEDIA_UPLOAD: 'media_upload',
  TF911: 'text_from_911',
  AIR_AMBULANCE: 'air_ambulance',
  TT911: 'text_to_911',
  ROADSIDE_ASSISTANCE: 'roadside_assistance',
  COMMUNICATOR_SUMMARIZATION_AND_KEYWORDS:
    'communicator_summarization_and_keywords',
  LIVE_VIDEO: 'live_video',
  CONNECT_SHARE_VIEW: 'connect_share_view',
  INTELLIGENT_ANALYST: 'intelligent_analyst',
  APP_LAUNCHER: 'app_launcher',
  UNITE_EVENT_PANE: 'unite_event_pane',
  AGENCY_SHARE_CHAT: 'agency_share_chat',
  GIS: 'gis',
} as const;

export const GPX_FEATURES = {
  CIRCUS_LIVE_VIDEO: 'circus_live_video',
  CIRCUS_MEDIA_UPLOAD: 'circus_media_upload',
  CIRCUS_DISPLAY_MEDIA: 'circus_display_media',
  TF911: 'text_from_911',
  TF911_PRECONFIGURED_RESPONSES: 'tf911_preconfigured_responses',
  TF911_OUTBOUND: 'text_from_911_outbound',
  VT911: 'video_to_911',
  GMR_AIR_AMBULANCE: 'gmr_air_ambulance',
  RCS911: 'rcs_to_911',
  TT911: 'text_to_911',
  ROADSIDE_ASSISTANCE: 'agero_roadside_assistance',
  KEYWORD_DETECTION: 'keyword_detection',
  CONNECT_SHARE_VIEW: 'connect_share_view',
  CALL_TRANSCRIPTION: 'call_transcription',
  INTELLIGENT_ANALYST: 'intelligent_analyst',
  APP_LAUNCHER: 'app_launcher',
  EVENT_PANE_NAVIGATION: 'event_pane_navigation',
  AGENCY_SHARE_CHAT: 'agency_share_chat',
  LIVE_VIDEO_TC: 'live_video_telecommunicator',
  LIVE_VIDEO_CALLER: 'live_video_caller',
  GIS: 'gis',
} as const;

export const GPX_PARTNERS = {
  CIRCUS: 'circus',
  GMR: 'GMR',
  GOOGLE: 'google',
  AGERO: 'agero',
} as const;

export const GPX_ROUTES = {
  MEDIA: 'Media',
  COMMUNICATOR: 'Communicator',
  MAP: 'Map',
  ADMIN: 'Admin',
  CONNECT_SHARE: 'Connect Share',
  TOOLS: 'Tools',
  EVENT_PANE: 'Event Pane',
  INTELLIGENT_ANALYST_SUMMARY: 'Intelligent Analyst Summary',
  INTELLIGENT_ANALYST_ANSWER_TIME_METRICS:
    'Intelligent Analyst Answer Time Metrics',
  INTELLIGENT_ANALYST_ADDITIONAL_METRICS:
    'Intelligent Analyst Additional Metrics',
  INTELLIGENT_ANALYST_AGENT_METRICS: 'Intelligent Analyst Agent Metrics',
  INTELLIGENT_ANALYST_HEATMAP: 'Intelligent Analyst Heatmap',
  LIVE_VIDEO: 'Live video caller UI',
} as const;

/**
 * These are root level event name identifiers (e.g., UNITE_USAGE).
 * Use specific names to distinguish different products/apps.
 */
export const GPX_EVENT_NAME = {
  UNITE_USAGE: 'UNITE usage',
  CONNECT_SHARE_USAGE: 'Connect Share usage',
  INTELLIGENT_ANALYST_USAGE: 'Intelligent Analyst usage',
} as const;

// Export type definitions for better TypeScript integration
export type GPXEventType =
  (typeof GPX_EVENT_TYPES)[keyof typeof GPX_EVENT_TYPES];
export type GPXCapability =
  (typeof GPX_CAPABILITIES)[keyof typeof GPX_CAPABILITIES];
export type GPXFeature = (typeof GPX_FEATURES)[keyof typeof GPX_FEATURES];
export type GPXPartner = (typeof GPX_PARTNERS)[keyof typeof GPX_PARTNERS];
export type GPXRoute = (typeof GPX_ROUTES)[keyof typeof GPX_ROUTES];
export type GPXEventName = (typeof GPX_EVENT_NAME)[keyof typeof GPX_EVENT_NAME];
